import { Controller } from '@hotwired/stimulus';

// 「給与を試す」ページの従業員数ステッパー (#1844)
// −/＋ ボタン・プリセットチップで人数を増減し、ガイドの「作成されるもの」件数を即時更新する。
export default class extends Controller {
  static targets = ['input', 'minus', 'plus', 'chip', 'count'];
  static values = { min: { type: Number, default: 1 }, max: { type: Number, default: 50 } };

  connect() {
    this.render();
  }

  decrement() {
    this.set(this.current - 1);
  }

  increment() {
    this.set(this.current + 1);
  }

  // プリセットチップ（data-value）から人数を設定
  preset(event) {
    this.set(Number(event.currentTarget.dataset.value));
  }

  // input 直接編集
  change() {
    this.set(this.current);
  }

  get current() {
    return Number(this.inputTarget.value || this.minValue);
  }

  clamp(v) {
    if (Number.isNaN(v)) return this.minValue;
    return Math.max(this.minValue, Math.min(this.maxValue, v));
  }

  set(v) {
    this.inputTarget.value = this.clamp(v);
    this.render();
  }

  render() {
    const n = this.clamp(this.current);
    // ガイドの従業員数・給与件数を更新
    this.countTargets.forEach((el) => { el.textContent = n; });
    // ボタンの無効状態
    if (this.hasMinusTarget) this.minusTarget.disabled = n <= this.minValue;
    if (this.hasPlusTarget) this.plusTarget.disabled = n >= this.maxValue;
    // チップの選択状態
    this.chipTargets.forEach((chip) => {
      chip.classList.toggle('on', Number(chip.dataset.value) === n);
    });
  }
}
